export const HubEndPointNames = {
  UserManagementChannelNotification: "UserManagementChannelNotification",
  GeneralChannelNotification: "GeneralChannelNotification",
  FacilityChannelNotification: "FacilityChannelNotification",
};
